import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../components/ui";
import { BenefitListDT } from "../../components/DataTables/BenefitListDT";

export const Benefits = () => {
  const navigate = useNavigate();

  return (
    <div className="p-card gap-4 p-3">
      <PageHeader title="Beneficios" onCreate={() => navigate("new")} createLabel="Crear beneficio" />
      <BenefitListDT />
    </div>
  );
};
